/**
 * game-sdk 埋点事件枚举与配置
 */

export enum GameTrackEvent {
  /** 发起 SSO 商户授权登录 */
  SSO_LOGIN_START = 'pba_sso_login_start',
  /** SSO 商户授权登录获得结果后 */
  SSO_LOGIN = 'pba_sso_login',
  /** 发行平台用户登出 */
  PUBLISH_ACCOUNT_LOGOUT = 'pba_publish_account_logout',
  /** 发行平台 token 续期 */
  PUBLISH_TOKEN_REFRESH = 'pba_publish_token_refresh',
}

/** 需要附带 base_url（HTTP 请求前后上报）的事件 */
export const HTTP_EVENTS = new Set<GameTrackEvent>([
  GameTrackEvent.SSO_LOGIN_START,
  GameTrackEvent.SSO_LOGIN,
  GameTrackEvent.PUBLISH_ACCOUNT_LOGOUT,
  GameTrackEvent.PUBLISH_TOKEN_REFRESH,
])

/** 需要附带 duration（会话时长）的事件 */
export const ADD_DURATION_PROPERTIES = [GameTrackEvent.SSO_LOGIN]

/** 授权发起的服务 */
export enum AuthSource {
  WEB = 1,
  ANDROID = 2,
  IOS = 3,
}

/** 授权最终结果 */
export enum AuthStatus {
  SUCCESS = 1,
  FAILED = 2,
  TIMEOUT = 3,
  CANCELLED = 4,
}
